function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { forwardRef, useMemo, useContext, useRef } from 'react';
import { Table as MuiTable, TableBody, TableContainer, TableHead, TableRow, Skeleton } from '@mui/material';
import TableContext from "./context";
import THeader from "./THeader";
import TEmpty from "./TEmpty";
import { TableVirtuoso } from 'react-virtuoso';
import TCell from "./TCell";
import Row from "./RowContent";
var VTable = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(TableContext),
    height = _useContext.height,
    columns = _useContext.columns,
    dataSource = _useContext.dataSource,
    loading = _useContext.loading,
    size = _useContext.size,
    showHeader = _useContext.showHeader;
  var data = useMemo(function () {
    if (loading) {
      return _toConsumableArray(new Array(Math.min(dataSource.length || 0, 40) || 10).keys());
    } else {
      if (dataSource.length === 0) {
        return [0];
      }
      return dataSource;
    }
  }, [loading, dataSource]);
  var VirtuosoTableComponents = useRef({
    Scroller: /*#__PURE__*/forwardRef(function (props, ref) {
      return /*#__PURE__*/React.createElement(TableContainer, _extends({}, props, {
        ref: ref
      }));
    }),
    Table: function Table(props) {
      return /*#__PURE__*/React.createElement(MuiTable, _extends({}, props, {
        sx: {
          tableLayout: 'fixed'
        }
      }));
    },
    TableHead: TableHead,
    TableRow: TableRow,
    TableBody: /*#__PURE__*/forwardRef(function (props, ref) {
      return dataSource.length === 0 && !loading ? /*#__PURE__*/React.createElement(TEmpty, null) : /*#__PURE__*/React.createElement(TableBody, _extends({}, props, {
        ref: ref
      }));
    })
  });
  var rowContent = function rowContent(_index, row) {
    return loading ? columns.map(function (column) {
      return /*#__PURE__*/React.createElement(TCell, {
        key: column.dataIndex,
        size: size,
        sx: {
          width: column.width,
          minWidth: column.minWidth
        }
      }, /*#__PURE__*/React.createElement(Skeleton, {
        variant: "text"
      }));
    }) : /*#__PURE__*/React.createElement(Row, {
      index: _index,
      row: row
    });
  };
  return /*#__PURE__*/React.createElement(TableVirtuoso, {
    style: {
      height: height
    },
    data: data,
    ref: ref,
    components: VirtuosoTableComponents.current,
    fixedHeaderContent: showHeader ? THeader : null,
    itemContent: rowContent
  });
});
export default VTable;